function getTimeRemaining(secondsRemaining) {
  const total = secondsRemaining;
  const seconds = Math.floor(secondsRemaining % 60);
  const minutes = Math.floor((secondsRemaining / 60) % 60);
  const hours = Math.floor((secondsRemaining / (60 * 60)) % 24);
  const days = Math.floor(secondsRemaining / (60 * 60 * 24));

  return {
    total,
    days,
    hours,
    minutes,
    seconds,
  };
}

function addSpans(number) {
  let text = number.toString(10);

  if (text.length < 2) {
    text = "0" + text;
  }
  return text
    .split("")
    .map((l) => "<span>" + l + "</span>")
    .join("");
}

function updateClockHtml(clock, secondsRemaining) {
  const timeRemaining = getTimeRemaining(secondsRemaining);
  clock
    .querySelectorAll(".Clock__days")
    .forEach((i) => (i.innerHTML = addSpans(timeRemaining.days)));

  clock
    .querySelectorAll(".Clock__hours")
    .forEach((i) => (i.innerHTML = addSpans(timeRemaining.hours)));

  clock
    .querySelectorAll(".Clock__minutes")
    .forEach((i) => (i.innerHTML = addSpans(timeRemaining.minutes)));

  clock
    .querySelectorAll(".Clock__seconds")
    .forEach((i) => (i.innerHTML = addSpans(timeRemaining.seconds)));
}

function initializeClock(clock) {
  //get deadline from html element
  const deadline = clock.getAttribute("data-deadline");
  console.log(deadline);
  let secondsRemaining =
    (Date.parse(deadline) - Date.now()) /
    //   + new Date().getTimezoneOffset() * 60 * 1000)
    1000;
  updateClockHtml(clock, Math.max(0, secondsRemaining));
  if (secondsRemaining <= 0) {
    return;
  }

  const timeInterval = setInterval(() => {
    secondsRemaining--;
    updateClockHtml(clock, Math.max(0, secondsRemaining));

    if (secondsRemaining <= 0) {
      clearInterval(timeInterval);
    }
  }, 1000);
}

export function initCounter() {
  console.log("initCounter");
  document
    .querySelectorAll(".ClockCounter")
    .forEach((clock) => initializeClock(clock));
}
